module.exports = __webpack_public_path__ + "05a6a8d3e2c889f4669583b2adad03a2.pdf";